import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import { Settings } from "lucide-react";
import loader from "../../../src/assets/Image/Loader2.gif";
import LotteryScanModal from "../Pages/AppPAges/Lottery/LotteryScanModal";
import { useShift } from "../Pages/AppPAges/Lottery/ShiftContext";

dayjs.extend(duration);
dayjs.extend(utc);

const ShiftBar = ({
  shiftTitle,
  shiftId,
  shiftStartAt,
  onOpenScanModal,
}) => {
  const [elapsed, setElapsed] = useState("00:00:00");
  const { shiftData, shiftDetails, loading: shiftLoading } = useShift();
  const [showScanModal, setShowScanModal] = useState(false);
  const [scannedTickets, setScannedTickets] = useState([]);

  const handleCloseScanModal = () => {
    setShowScanModal(false);
  };

  const handleScanSuccess = (newTickets) => {
    const ticketsArray = Array.isArray(newTickets) ? newTickets : [newTickets];
    setScannedTickets((prev) => [...prev, ...ticketsArray]);
    setShowScanModal(false);
  };

  useEffect(() => {
    const startAt = shiftStartAt || shiftData?.shift_start_at;

    if (
      shiftLoading ||
      !shiftData?.is_active ||
      !startAt ||
      !dayjs(startAt).isValid()
    ) {
      setElapsed("00:00:00");
      return;
    }

    const updateElapsed = () => {
      const start = dayjs(startAt);
      const now = dayjs();
      const diff = now.diff(start);
      const durationObj = dayjs.duration(diff);

      const hours = String(Math.floor(durationObj.asHours())).padStart(2, "0");
      const minutes = String(durationObj.minutes()).padStart(2, "0");
      const seconds = String(durationObj.seconds()).padStart(2, "0");

      setElapsed(`${hours}:${minutes}:${seconds}`);
    };

    updateElapsed();

    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval);
  }, [
    shiftLoading,
    shiftData?.is_active,
    shiftStartAt,
    shiftData?.shift_start_at,
  ]);

  return (
    <>
      <div className="user-content shift-profile-content">
        <img
          src={loader}
          className="avatar responsive-avatar shift-loader-avatar"
          alt="Shift Active"
        />

        <div className="user-names-wrapper">
          <div className="user-names">
            <div className="user-fullname shift-timer-text">
              {elapsed}
            </div>

            <div className="user-greeting shift-title-text">
              {shiftTitle || shiftData?.title || "Active Shift"}
            </div>
          </div>
        </div>

        <div className="settings-icon">
          <Settings className="responsive-settings" size={35} />
        </div>
      </div>

      {!onOpenScanModal && (
        <LotteryScanModal
          show={showScanModal}
          onClose={handleCloseScanModal}
          shiftDetails={shiftDetails}
          shiftId={shiftId || shiftData?.shift_id}
          onScanSuccess={handleScanSuccess}
          scannedTickets={scannedTickets}
        />
      )}
    </>
  );
};

export default ShiftBar;